import { useCallback } from 'react';
import { useModal } from 'react-modal-hook';

import { useChangeCustomerLogoMutation } from '@/graphql';
import ChangeAvatarModal from '@/modals/ChangeAvatarModal';
import { GetCustomerQuery } from '@/types/graphql';
import { trackClientProfileUpdated } from '@/util/vexo';

const useChangeLogoModal = (
  customer: GetCustomerQuery['customer'] | null | undefined,
) => {
  const [changeCustomerLogo] = useChangeCustomerLogoMutation();

  const handleUpload = useCallback(
    async (logoKey: string) => {
      const result = await changeCustomerLogo({
        variables: { logoKey, customerId: customer!.id },
      });
      // Vexo `client_profile_updated` (CSV #3) — customer logo change.
      // Reaching here means the mutation resolved; the ChangeAvatarModal
      // wraps this handler so errors bubble there.
      trackClientProfileUpdated({
        fields_updated: ['logo'],
        update_type: 'manual',
      });
      return result;
    },
    [customer?.id],
  );

  const [showModal, hideModal] = useModal(
    () => (
      <ChangeAvatarModal
        currentAvatarUrl={customer?.logoUrl ?? null}
        hideModal={hideModal}
        onUpload={handleUpload}
      />
    ),
    [customer?.logoUrl],
  );

  return showModal;
};

export default useChangeLogoModal;
